import { render, staticRenderFns } from "./PageLayoutWrapper.vue?vue&type=template&id=0826ef86&"
import script from "./PageLayoutWrapper.vue?vue&type=script&lang=js&"
export * from "./PageLayoutWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PageLayoutWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports